import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import Process from "@/components/Process";
import WhyUs from "@/components/WhyUs";
import Reviews from "@/components/Reviews";
import InstagramFeed from "@/components/InstagramFeed";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function Home() {
  useEffect(() => {
    document.title = "Klusbedrijf Pruijn | Renovaties, Verbouwingen & Afwerking Arnhem";
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, []);

  return (
    <div className="bg-[#050505] min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Process />
      <WhyUs />
      <Reviews />
      <InstagramFeed />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
